import { createStoreContext } from 'reusable/mobx-store-utils/storeUtils'
import { UserOrgWithOrgDto } from '@gap/backend/app-services/user-org/models/UserOrgWithOrgDto'

export enum AdvisorSignUpEnum {
   trial = 'trial',
   register = 'register',
   completeXeroSignup = 'complete-xero-signup'
}

interface Progress {
   step: number
   totalSteps: number
}

interface SignUpAdvisorStoreProps {
   signUpAction: AdvisorSignUpEnum
   queryString: URLSearchParams
}

export default class SignUpAdvisorStore {
   sp
   trialOrg: UserOrgWithOrgDto | undefined
   progress: Progress | undefined
   invitationDetails

   constructor(sp: SignUpAdvisorStoreProps) {
      this.sp = sp
      this.invitationDetails = {
         email: this.sp.queryString.get('email'),
         fromOrg: this.sp.queryString.get('advisorOrg'),
         fromName: this.sp.queryString.get('advisorUser'),
         orgId: this.sp.queryString.get('orgId')
      }
   }

   get action() {
      return this.sp.signUpAction
   }

   get registrationMethod() {
      return this.sp.signUpAction === 'trial'
         ? 'Trial'
         : this.sp.signUpAction === 'complete-xero-signup'
            ? 'Xero Marketplace'
            : 'Invitation'
   }

   get isInvitation() {
      return !!this.invitationDetails.email?.length
   }
}

export const { Provider: SignUpAdvisorStoreProvider, useProvidedStore: useSignUpAdvisorStore } = createStoreContext(SignUpAdvisorStore) 